__webpack_public_path__ = require('script-path')('vsclient');



// WEBPACK FOOTER //
// /src/preload.js